import React from 'react';
import AuthDF from '../components/SimulatorsComponents/DefualtSimulators/AuthDF';
//= ========================================================================
const Sim_T02_Auth = ({
  globJSON,
  simPlatform,
  language,
  notSkipped,
  slideshowRefs,
}) => (
  <AuthDF
    globJSON={globJSON}
    simPlatform={simPlatform}
    language={language}
    notSkipped={notSkipped}
    slideshowRefs={slideshowRefs}
  />
);
export default Sim_T02_Auth;
